import { type Id, type ToastOptions, toast } from 'react-toastify';

export interface ToastMethods {
  success: (message: string, options?: ToastOptions) => Id;
  error: (message: string | undefined, options?: ToastOptions) => Id;
  info: (message: string, options?: ToastOptions) => Id;
  warning: (message: string, options?: ToastOptions) => Id;
  clear: (toastId?: Id) => void;
}

interface ToastrHook {
  toastr: ToastMethods;
}

const defaultOptions: ToastOptions = {
  position: 'top-right',
  autoClose: 3000,
  hideProgressBar: false,
  closeOnClick: true,
  pauseOnHover: true,
  draggable: true,
};

export const useCustomToast = (): ToastrHook => {
  const toastr: ToastMethods = {
    success: (message: string, options?: ToastOptions): Id => {
      return toast.success(message, { ...defaultOptions, ...options });
    },
    error: (message: string | undefined, options?: ToastOptions): Id => {
      return toast.error(message || 'An error occurred', { ...defaultOptions, ...options });
    },
    info: (message: string, options?: ToastOptions): Id => {
      return toast.info(message, { ...defaultOptions, ...options });
    },
    warning: (message: string, options?: ToastOptions): Id => {
      return toast.warning(message, { ...defaultOptions, ...options });
    },
    clear: (toastId?: Id): void => {
      toast.dismiss(toastId);
    },
  };

  return { toastr };
};
